import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  AuthStatus,
  authenticateAsync,
  getAvailableProviders,
} from "./utils/auth";
import Unauthorized from "./Unauthorized";
import LoginChooser from "./LoginChooser";

const status = await authenticateAsync();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {status === AuthStatus.Authenticated ? (
      <App />
    ) : status === AuthStatus.ChooseProvider ? (
      <LoginChooser providers={getAvailableProviders()} />
    ) : (
      <Unauthorized />
    )}
  </React.StrictMode>,
);
